import { render, staticRenderFns } from "./cattle.vue?vue&type=template&id=0a3c524e&scoped=true"
import script from "./cattle.vue?vue&type=script&lang=js"
export * from "./cattle.vue?vue&type=script&lang=js"
import style0 from "./cattle.vue?vue&type=style&index=0&id=0a3c524e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3c524e",
  null
  
)

export default component.exports